export default "__VITE_PUBLIC_ASSET__eae7610f__"